const handleDeleteCompanyFailformCampany = {
  title: 'DOCUMENT CANNOT BE DELETED'
};

export default handleDeleteCompanyFailformCampany;
